import Vue from 'vue'
// import _ from 'lodash'

/* eslint-disable */
export default {
  namespaced: true,
  state: {
    loading: false,
    error: false,
    subusers: []
  },
  actions: {
    // getOmbrelloni ({commit, rootState}) {
    //   console.log('getOmbrelloni: ')
    //   commit('SET_LOADING', true)
    //   Vue.http
    //     .get(process.env.VUE_APP_API + '/ombrelloni/app',
    //     {
    //       headers: {
    //         'Authorization': 'Bearer ' + rootState.jwt.jwt
    //       }
    //     },
    //     ).then(response => {
    //       // console.log(response)
    //       commit('LOAD_OMBRELLONI', response.data.ombrells)
    //       // commit('SET_LOADING', false)
    //     })
    // }
    addSubuser ({rootState, commit, dispatch}, data) {
      console.log('addSubuser: ', data)
      commit('SET_LOADING', true)
      Vue.http
        .post(process.env.VUE_APP_API + '/subuser/add', { subuser: data, hotel: rootState.hotels.activehotel },
        {
          headers: {
            'Authorization': 'Bearer ' + rootState.jwt.jwt
          }
        },
        ).then(response => {
          console.log(response.data)
          dispatch('hotels/getHotels', null, {root: true})
          // commit('hotels/RELOAD_ACTIVEHOTEL', null, {root: true})
          commit('SET_LOADING', false)
        })
    },
    removeSubuser ({rootState, commit, dispatch}, data) {
      console.log('removeSubuser: ', data)
      commit('SET_LOADING', true)
      Vue.http
        .post(process.env.VUE_APP_API + '/subuser/remove', { subuser: data, hotel: rootState.hotels.activehotel },
        {
          headers: {
            'Authorization': 'Bearer ' + rootState.jwt.jwt
          }
        },
        ).then(response => {
          console.log(response.data)
          dispatch('hotels/getHotels', null, {root: true})
          // commit('hotels/RELOAD_ACTIVEHOTEL', null, {root: true})
          commit('SET_LOADING', false)
        })
    },
    updateSubuser ({rootState, commit, dispatch}, data) {
      console.log('updateSubuser: ', data)
      commit('SET_LOADING', true)
      Vue.http
        .post(process.env.VUE_APP_API + '/subuser/update', { subuser: data, hotel: rootState.hotels.activehotel },
        {
          headers: {
            'Authorization': 'Bearer ' + rootState.jwt.jwt
          }
        },
        ).then(response => {
          console.log(response.data)
          dispatch('hotels/getHotels', null, {root: true})
          // commit('hotels/RELOAD_ACTIVEHOTEL', null, {root: true})
          commit('SET_LOADING', false)
        })
    }
  },
  mutations: {
    SET_LOADING (state, data) {
      state.loading = data
    }
  },
  getters: {}
}
